import './style.css';

export const Footer = () => {

   return (
      <>
         <div className="footer">
            <span>made by Baurzhan Abenov</span>
            <span>nFactorial Incubator 2022</span>
            {/* <a href="https://www.instagram.com/nfactorial.school/">nFactorial Incubator 2022</a> */}
         </div>
      </>
   );
};
